import { post } from '../../01-helpers/services/ajax';

export default function getQuestions(selectedExamTypeId, selectedRuleId) {
    return post (
        '/api/golfexam/GetGolfExamQuestions',
        {
            data: {
                selectedExamTypeId,
                selectedRuleId
            }
        }
    );
};